<template>
  <div class="main_Container">
    <section class="p-4">
      <div class="container-fluid">
        <div v-show="this.isloading" class="data__loading">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

        <div v-show="!this.isloading" class="card">
          <div class="card-body">
            <div class="backgroundImage">
              <div class="backgroudColor"></div>
            </div>
            <div class="user__info">
              <div class="user__info__image">
                <div class="image">
                  <img :src="this.user.photo" alt="user-image" />
                </div>
              </div>
              <div class="user__info__name text-center">
                <h3>{{ fullname }}</h3>
              </div>
              <div class="user__info__details">
                <form @submit.prevent="updateCurrentUser">
                  <div class="row">
                    <!-- First Name -->
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label for="firstName">الاسم الاول</label>
                        <input
                          type="text"
                          id="firstName"
                          class="form-control"
                          placeholder="الاسم"
                          :value="user.firstName"
                          @input="newValue($event, 'firstName')"
                          required
                        />
                      </div>
                    </div>
                    <!-- Last Name -->
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label for="lastName">الاسم الاخير</label>
                        <input
                          type="text"
                          id="lastName"
                          class="form-control"
                          placeholder="الاسم"
                          :value="user.lastName"
                          @input="newValue($event, 'lastName')"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <!-- Right Side -->
                    <div class="col-lg-6">
                      <div class="row">
                        <!-- Email -->
                        <div class="col-12">
                          <div class="form-group">
                            <label for="email">البريد الالكتروني</label>
                            <input
                              type="email"
                              id="email"
                              class="form-control"
                              placeholder="البريد الالكتروني"
                              :value="user.email"
                              readonly
                              disabled
                            />
                          </div>
                        </div>
                        <!-- Password
                        <div class="col-12">
                          <div class="form-group">
                            <label for="password">كلمة المرور</label>
                            <input
                              type="password"
                              id="password"
                              class="form-control"
                              placeholder="كلمة المرور"
                              :value="user.password"
                              @input="newValue($event, 'password')"
                            />
                          </div>
                        </div> -->
                      </div>
                    </div>
                    <!-- left Side -->
                    <div class="col-lg-6">
                      <!-- User Image -->
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <label>صورة المستخدم</label>
                            <UploadImages
                              class="form-control"
                              @changed="handleImages"
                              :max="1"
                              maxError="يمكنك رفع صورة واحدة لكل درس"
                              fileError="لا يمكن رفع ملفات غير الصور"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- submit -->
                  <div class="text-start pt-3 pb-3">
                    <button
                      type="submit"
                      v-if="!this.updateLoading"
                      class="btn btn-primary"
                    >
                      حفظ
                    </button>
                    <!-- button Save with Loading -->
                    <button
                      type="button"
                      class="btn btn-primary"
                      :disabled="this.updateLoading"
                      v-if="this.updateLoading"
                      v-cloak
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      جاري الحفظ...
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Upload Image Drag and Drop
import UploadImages from "vue-upload-drop-images";
// Vuex
import { mapActions, mapGetters } from "vuex";
// Swal
import Swal from "sweetalert2";
// Firebase Upload Component
import FirebaseUploadingFileVue from "@/components/FirebaseUploadingFile.vue";
// Toast to Show Message
import { useToast, TYPE } from "vue-toastification";
const toast = useToast();

export default {
  data() {
    return {
      isloading: false,
      updateLoading: false,
      image: null,
      user: {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
      },
      updatedUser: undefined,
    };
  },
  components: {
    UploadImages,
  },
  methods: {
    ...mapActions("adminModule", ["updateUser"]),

    async updateCurrentUser() {       
    if (this.updatedUser == undefined && this.image==undefined)
    {
      this.failedMessage();
      return;
    }
    else {  
     this.updateLoading = true;
      if (this.image !== null) {
        const content = {
          component: FirebaseUploadingFileVue,
          props: {
            title: "يتم رفع الصورة الان",
            file: this.image,
            collection: "IMAGEs",
            onFinished: (url) => {
              // Only the changed fields go to Firestore; `this.user` is merged
              // locally just to refresh the view.
              this.updatedUser = { ...this.updatedUser, photo: url ?? "" };
              this.image = null;

              toast.dismiss(toastId);
              this.user = { ...this.user, ...this.updatedUser };
              this.updateUser(this.updatedUser);
              this.updateLoading = false;
              this.clearAndShowSuccess();
            },
          },
        };

        const toastId = toast(content, {
          icon: false,
          hideProgressBar: true,
          closeButton: false,
          type: TYPE.INFO,
          timeout: false,
          toastClassName: "my-custom-toast-class",
        });
      } else {
        this.user = { ...this.user, ...this.updatedUser };
        await this.updateUser(this.updatedUser);
        this.clearAndShowSuccess();
        this.updateLoading = false;
      }

    }
    },
    // Handle Drag and Drop Component
    handleImages(files) {
      this.image = files[0];
      // this.lessonImage = file;
    },
    // New Value
    // Sends ONLY the edited fields. Spreading the whole cached user here meant
    // a profile edit wrote `permissions` back too, restoring permissions an
    // admin had just revoked.
    newValue($event, key) {
      this.updatedUser = {
        ...this.updatedUser,
        [key]: $event.target.value,
      };
    },

    //-----------------------------------------------------//
    // clear Data when close modal
    clearData() {
      this.image = null;
      this.updatedUser = {};
    },
    failedMessage(){
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "error",
        title: "قم بتعديل البيانات",
      });
    },
    // On Upload Image
    seccussAdd() {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: "تم التعديل بنجاح",
      });
    },
    // All Two functions
    clearAndShowSuccess() {
      this.seccussAdd();
      this.clearData();
    },
  },

  async created() {},

  computed: {
    ...mapGetters("adminModule", ["getUser", "isLoading"]),

    fullname() {
      return this.user.firstName + " " + this.user.lastName;
    },
  },
  mounted() {
    this.user = this.getUser;
    this.isloading = this.isLoading;
  },
  watch: {
    getUser() {
      this.user = this.getUser;
    },
    isLoading() {
      this.isloading = this.isLoading;
    },
  },
};
</script>


<style lang="scss" scoped>
.card {
  overflow: hidden;
}
.backgroundImage {
  position: relative;
  width: 100%;
  height: 250px;
  .backgroudColor {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("../../assets/profile__head.jpg");
    background-size: cover;
    background-position: center;
  }
}
.user__info {
  position: relative;
  width: 100%;
  $circle: 120px;
  margin-top: calc($circle / -2);
  &__image {
    position: relative;
    height: $circle;
    margin-bottom: 10px;
    .image {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: $circle;
      height: $circle;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  &__name {
    margin-bottom: 20px;
  }
  &__details {
    padding: 0 40px;
  }
}
</style>